import { MutationTree } from 'vuex';
import { State } from '@/store/modules/k8/k8CommonState/k8.store';
import { KeyLabel } from '@/store/mutations-typesCommon';
import { Service } from '@/utils/types/global';
import { initialState } from '@/store/modules/k8/k8CommonState/k8.store';

const mutations: MutationTree<State> = {
  setCurrentK8Tab(state: State, data: String) {
    state.currentK8Tab = data;
  },
  setCurrentValue(state: State, data: any) {
    state[data.type] = data.value;
  },
  setCurrentRouteConfig(state: State, data: Array<any>) {
    state.currentRoute = data;
  },
  setCurrentNamespace(state: State, data: KeyLabel) {
    state.currentNamespace = data;
  },
  setCurrentStateful(state: State, data: KeyLabel) {
    state.currentStatefulset = data;
  },
  setCurrentDaemon(state: State, data: KeyLabel) {
    state.currentDaemonset = data;
  },
  setCurrentWorkload(state: State, data: KeyLabel) {
    state.currentWorkload = data;
  },
  setCurrentDep(state: State, data: KeyLabel) {
    state.currentDep = data;
  },
  setCurrentCluster(state: State, data: Service) {
    state.currentCluster = data;
  },
  setClusters(state: State, data: Array<Service>) {
    state.k8Clusters = data;
  },
  setDeps(state: State, data: Array<KeyLabel>) {
    state.k8Deployments = data;
  },
  setNamespaces(state: State, data: Array<KeyLabel>) {
    state.k8Namespaces = data;
  },
  setWorkloads(state: State, data: Array<KeyLabel>) {
    state.k8Workloads = data;
  },
  setStatefulsets(state: State, data: Array<KeyLabel>) {
    state.k8Statefulsets = data;
  },
  setDaemonsets(state: State, data: Array<KeyLabel>) {
    state.k8Daemonsets = data;
  },
  setK8NodeEntities(state: State, data: Array<KeyLabel>) {
    state.k8NodeEntities = data;
  },
  setDefaultValues(state: State) {
    Object.assign(state, { ...initialState });
  },
};

export default mutations;
